
import React, { useEffect, useState } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  MenuItem,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';
import { useAppContext } from '../context/AppContext';

function Employment() {
  const { state, actions } = useAppContext();
  
  const [value,setValues] = useState({
    occupation: state.occupation || '',
    employer: state.employer || '',
    dependents: state.dependents || '',
  });

  useEffect(() => {
    setValues(
      {
        occupation: state.occupation || '',
        employer: state.employer || '',
        dependents: state.dependents || '',
      }
    )
  }, [state.occupation, state.employer, state.dependents])
  
  const handleChange = (field) => (e) => {
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value);
  };
  

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };

  return (
    <Box>
      <CardContent>
      <Box sx={{ mb: 2}}>
      <Typography variant='h6' sx={{mb:2, color: 'primary.main'}}>
            Your Employment Details
          </Typography>
          {/* <Typography variant="body1" component="h2" gutterBottom>
           Current Occupation
          </Typography>
      
          <TextField
            value={state.occupation || ''}
            onChange={(e) => actions.updateFormData('occupation', e.target.value)}
            fullWidth
            placeholder="Designation or Role"
          /> */}
        </Box>

        <Box sx={{ mt: 2 }}>
        <FormControl fullWidth>
        <Select
        fullWidth
          value={value.occupation || 'Select Occupation'}
          onChange={(e) => actions.updateFormData('occupation', e.target.value)}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
        >
          <MenuItem value="Select Occupation">
            <em>Select Occupation</em>
          </MenuItem>
          <MenuItem value={'salaried'}>Salaried</MenuItem>
          <MenuItem value={'Business'}>Business / Self-Employed</MenuItem>
          <MenuItem value={'Retired'}>Retired</MenuItem>
        </Select>
        {/* <FormHelperText>Without label</FormHelperText> */}
      </FormControl>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
           Company Name
          </Typography>
      
          <TextField
            value={value.employer || ''}
            onChange={(e) => actions.updateFormData('employer', e.target.value)}
            fullWidth
            placeholder="Company Name"
          />
        </Box>
        
        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
         Number of Financial Dependents
        </Typography>
        
          <TextField
            value={formatNumber(value.dependents) || ''}
            onChange={(e) => actions.updateFormData('dependents', e.target.value)}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='Children + Spouse + Parents + others'
          />
        </Box>
      </CardContent>
</Box>
  );

}

export default Employment;